import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useMarket } from '../context/MarketContext';

export const MarketLink = ({ to, children, ...props }) => {
    const { getMarketPath } = useMarket();
    const resolvedTo = typeof to === 'string' ? getMarketPath(to) : to;
    return (
        <Link to={resolvedTo} {...props}>
            {children}
        </Link>
    );
};

export const MarketNavLink = ({ to, children, ...props }) => {
    const { getMarketPath } = useMarket();
    const resolvedTo = typeof to === 'string' ? getMarketPath(to) : to;
    return (
        <NavLink to={resolvedTo} {...props}>
            {children}
        </NavLink>
    );
};

export default MarketLink;
